import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelDynamic as _vModelDynamic, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d7616ca4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "NewLogin"
};
var _hoisted_2 = {
  key: 0,
  "class": "message__holder"
};
var _hoisted_3 = {
  "class": "message"
};
var _hoisted_4 = {
  key: 1,
  "class": "loader"
};
var _hoisted_5 = {
  key: 2,
  "class": "NewLogin__register"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "Register Your Free Account", -1);
});
var _hoisted_7 = {
  "class": "input__container"
};
var _hoisted_8 = {
  "class": "input__container"
};
var _hoisted_9 = ["type"];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "black"
  }, [/*#__PURE__*/_createTextVNode("By registering, you agree to our "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.aivitar.com/terms-and-conditions",
    target: "_system"
  }, "Terms of Service.")], -1);
});
var _hoisted_11 = {
  "class": "bottomItems"
};
var _hoisted_12 = ["disabled"];
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "bluelink"
  }, " Login", -1);
});
var _hoisted_14 = {
  key: 3,
  "class": "NewLogin__signin"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Login to your account", -1);
});
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "subtitle"
  }, "Let's get you back to where you belong, your friends are missing you", -1);
});
var _hoisted_17 = {
  "class": "input__container"
};
var _hoisted_18 = {
  "class": "input__container"
};
var _hoisted_19 = ["type"];
var _hoisted_20 = {
  "class": "bottomItems"
};
var _hoisted_21 = ["disabled"];
var _hoisted_22 = {
  key: 4,
  "class": "NewLogin__password-reset"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Password Recovery", -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "subtitle"
  }, "Having issues logging in? Let us help you resolve that.", -1);
});
var _hoisted_25 = {
  "class": "input__container"
};
var _hoisted_26 = {
  "class": "bottomItems"
};
var _hoisted_27 = ["disabled"];
var _hoisted_28 = {
  key: 5,
  "class": "NewLogin__password-reset"
};
var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Password Reset", -1);
});
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "subtitle"
  }, "If your token is valid the form below can reset your password on your account ", -1);
});
var _hoisted_31 = {
  "class": "input__container"
};
var _hoisted_32 = {
  "class": "bottomItems"
};
var _hoisted_33 = ["disabled"];
var _hoisted_34 = {
  key: 6,
  "class": "NewLogin__verification"
};
var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Redirecting to Checkout", -1);
});
var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "subtitle"
  }, "One minute while we redirect you", -1);
});
var _hoisted_37 = [_hoisted_35, _hoisted_36];
var _hoisted_38 = {
  key: 7,
  "class": "NewLogin__verification"
};
var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "Verify Your Email", -1);
});
var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "subtitle"
  }, "Please check your email for a link to verify your account", -1);
});
var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "subtitle"
  }, "If you don't see the email, check your spam folder or try to authenticate another way ", -1);
});
var _hoisted_42 = [_hoisted_39, _hoisted_40, _hoisted_41];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_LoaderComponent = _resolveComponent("LoaderComponent");
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("form", {
    onSubmit: _cache[25] || (_cache[25] = _withModifiers(function () {
      return _ctx.register && _ctx.register.apply(_ctx, arguments);
    }, ["prevent"]))
  }, [_ctx.message.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1)])) : _createCommentVNode("", true), _ctx.showLoader ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_LoaderComponent, {
    "class": "loaderComp",
    largeText: "",
    smallText: "One Sec.."
  })])) : _createCommentVNode("", true), !_ctx.$store.state.showPasswordReset && _ctx.showRegistration && !_ctx.$store.state.showUserLogin ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "text",
    placeholder: "First Name",
    autocapitalize: "on",
    autocomplete: "given-name",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.firstname = $event;
    })
  }, null, 512), [[_vModelText, _ctx.firstname]]), _createElementVNode("div", {
    "class": _normalizeClass({
      'input__description': true,
      'required': _ctx.firstnameError
    })
  }, _toDisplayString(_ctx.firstnameError ? _ctx.firstnameError : '* Required'), 3)]), _withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "email",
    autocomplete: "email",
    id: "current-username",
    autocapitalize: "on",
    placeholder: "Email Address",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.email = $event;
    })
  }, null, 512), [[_vModelText, _ctx.email]]), _createElementVNode("div", {
    "class": _normalizeClass({
      'input__description': true,
      'required': _ctx.emailError
    })
  }, _toDisplayString(_ctx.emailError ? _ctx.emailError : '* Required'), 3), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    "class": "formInput",
    onKeyup: _cache[2] || (_cache[2] = _withKeys(function () {
      return _ctx.register && _ctx.register.apply(_ctx, arguments);
    }, ["enter"])),
    name: "password-signin",
    id: "new-password",
    type: _ctx.showPassword === true ? 'text' : 'password',
    placeholder: "Password",
    autocomplete: "new-password",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.password = $event;
    })
  }, null, 40, _hoisted_9), [[_vModelDynamic, _ctx.password]]), _ctx.showPassword ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    style: {
      "float": "right"
    },
    icon: ['fa', 'eye'],
    "class": "eye fa fa-eye",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.showPassword = false;
    }),
    "&&": "",
    "password.length": ""
  })) : _createCommentVNode("", true), !_ctx.showPassword && _ctx.password.length ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    style: {
      "float": "right"
    },
    "class": "eye fa fa-eye",
    icon: ['fa', 'eye-slash'],
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.showPassword = true;
    })
  })) : _createCommentVNode("", true)]), _createElementVNode("div", {
    "class": _normalizeClass({
      'input__description': true,
      'required': _ctx.passwordError
    })
  }, _toDisplayString(_ctx.passwordError ? _ctx.passwordError : '* Required'), 3)]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _mergeProps({
    "class": "formButton registerButtonHit",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.register();
    }),
    disabled: _ctx.password.length < 8 || _ctx.email.length < 4 || _ctx.lastname.length < 1 || _ctx.firstname.length < 1
  }, null), " Sign Up ", 16, _hoisted_12), _createElementVNode("div", {
    id: "already-have-account",
    "class": "clickableText",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      _ctx.showLogin = true;
      _ctx.showRegistration = false;
      _ctx.message = '';
    })
  }, [_createTextVNode(" Already have an account? "), _hoisted_13])])])) : _createCommentVNode("", true), !_ctx.$store.state.showPasswordReset && (_ctx.showLogin || _ctx.$store.state.showUserLogin) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _hoisted_16, _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "email",
    autocomplete: "email",
    autocapitalize: "on",
    placeholder: "Email Address",
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return _ctx.email = $event;
    })
  }, null, 512), [[_vModelText, _ctx.email]]), _ctx.email.length < 3 || _ctx.emailError ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass({
      'input__description': true,
      'required': _ctx.emailError
    })
  }, _toDisplayString(_ctx.emailError ? _ctx.emailError : '* Required'), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("input", {
    onKeyup: _cache[9] || (_cache[9] = _withKeys(function () {
      return _ctx.userLogin && _ctx.userLogin.apply(_ctx, arguments);
    }, ["enter"])),
    name: "password-login",
    "class": "formInput passwordInput",
    type: _ctx.showPassword === true ? 'text' : 'password',
    placeholder: "Password",
    autocomplete: "current-password",
    id: "current-password",
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return _ctx.password = $event;
    })
  }, null, 40, _hoisted_19), [[_vModelDynamic, _ctx.password]]), _ctx.showPassword ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    style: {
      "float": "right"
    },
    icon: ['fa', 'eye'],
    "class": "eye fa fa-eye",
    onClick: _cache[11] || (_cache[11] = function ($event) {
      return _ctx.showPassword = false;
    }),
    "&&": "",
    "password.length": ""
  })) : _createCommentVNode("", true), !_ctx.showPassword && _ctx.password.length ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    style: {
      "float": "right"
    },
    "class": "eye fa fa-eye",
    icon: ['fa', 'eye-slash'],
    onClick: _cache[12] || (_cache[12] = function ($event) {
      return _ctx.showPassword = true;
    })
  })) : _createCommentVNode("", true), _ctx.password.length < 3 || _ctx.passwordError ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    "class": _normalizeClass({
      'input__description': true,
      'required': _ctx.passwordError
    })
  }, _toDisplayString(_ctx.passwordError ? _ctx.passwordError : '* Required'), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _mergeProps({
    id: "login-button",
    "class": "formButton",
    onClick: _cache[13] || (_cache[13] = function ($event) {
      return _ctx.userLogin();
    }),
    disabled: _ctx.password.length < 8 || _ctx.email.length < 4 || _ctx.lastname.length < 1 || _ctx.firstname.length < 1
  }, null), " Sign In ", 16, _hoisted_21), _createElementVNode("div", {
    "class": "clickableText",
    onClick: _cache[14] || (_cache[14] = function ($event) {
      _ctx.showLogin = false;
      _ctx.showRegistration = true;
      _ctx.message = '';
      _ctx.$store.commit('updateShowUserLogin', false);
    })
  }, " Need a new account? Register Here "), _createElementVNode("div", {
    "class": "clickableText",
    onClick: _cache[15] || (_cache[15] = function ($event) {
      _ctx.showLogin = false;
      _ctx.showRegistration = false;
      _ctx.showForgotPassword = true;
      _ctx.message = '';
    })
  }, " Forgot Password? ")])])) : _createCommentVNode("", true), !_ctx.$store.state.showPasswordReset && _ctx.showForgotPassword ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _hoisted_24, _createElementVNode("div", _hoisted_25, [_withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "email",
    autocomplete: "email",
    autocapitalize: "on",
    placeholder: "Email Address",
    "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
      return _ctx.email = $event;
    })
  }, null, 512), [[_vModelText, _ctx.email]]), _ctx.email.length < 3 || _ctx.emailError ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass({
      'input__description': true,
      'required': _ctx.emailError
    })
  }, _toDisplayString(_ctx.emailError ? _ctx.emailError : '* Required'), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _mergeProps({
    "class": "formButton",
    onClick: _cache[17] || (_cache[17] = function ($event) {
      return _ctx.requestPasswordReset();
    }),
    disabled: _ctx.email.length < 4
  }, null), " Request Password Reset ", 16, _hoisted_27), _createElementVNode("div", {
    "class": "clickableText",
    onClick: _cache[18] || (_cache[18] = function ($event) {
      _ctx.showForgotPassword = false;
      _ctx.showLogin = false;
      _ctx.showRegistration = true;
      _ctx.message = '';
      _ctx.$store.commit('updateShowUserLogin', false);
    })
  }, " Need a new account? Register Here "), _createElementVNode("div", {
    "class": "clickableText",
    onClick: _cache[19] || (_cache[19] = function ($event) {
      _ctx.showForgotPassword = false;
      _ctx.showLogin = true;
      _ctx.showRegistration = false;
      _ctx.message = '';
    })
  }, " Already have an account? Login ")])])) : _createCommentVNode("", true), _ctx.$store.state.showPasswordReset ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _hoisted_30, _createElementVNode("div", _hoisted_31, [_withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "password",
    placeholder: "Password",
    autocomplete: "new-password",
    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
      return _ctx.password = $event;
    })
  }, null, 512), [[_vModelText, _ctx.password]]), _withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "password",
    placeholder: "Password",
    autocomplete: "new-password",
    "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
      return _ctx.passwordVerify = $event;
    })
  }, null, 512), [[_vModelText, _ctx.passwordVerify]])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _mergeProps({
    "class": "formButton",
    onClick: _cache[22] || (_cache[22] = function ($event) {
      return _ctx.resetMyPassword();
    }),
    disabled: _ctx.email.length < 4
  }, null), " Reset Password ", 16, _hoisted_33), _createElementVNode("div", {
    "class": "clickableText",
    onClick: _cache[23] || (_cache[23] = function ($event) {
      _ctx.turnOffShowPasswordReset();
      _ctx.showForgotPassword = false;
      _ctx.showLogin = false;
      _ctx.showRegistration = true;
      _ctx.message = '';
      _ctx.$store.commit('updateShowUserLogin', false);
    })
  }, " Need a new account? Register Here "), _createElementVNode("div", {
    "class": "clickableText",
    onClick: _cache[24] || (_cache[24] = function ($event) {
      _ctx.turnOffShowPasswordReset();
      _ctx.showForgotPassword = false;
      _ctx.showLogin = true;
      _ctx.showRegistration = false;
      _ctx.message = '';
    })
  }, " Already have an account? Login ")])])) : _createCommentVNode("", true), _ctx.showRedirectToCheckout ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37)) : _createCommentVNode("", true), _ctx.showVerification ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_42)) : _createCommentVNode("", true)], 32)]);
}